//  Закомментируйте строку ниже если блок "Спикеры" не будет использоваться
import SpeakersConfiguration from '@/configurations/content/wecloud/speakers'
//  Закомментируйте строку ниже если блок "Партнеры" не будет использоваться
import PartnersConfiguration from '@/configurations/content/wecloud/partners' // @/configurations/content/vtb/partners-dark для темной темы

export default {
  pageTitle: 'Process Mining: неслабое звено. Устраняем уязвимые места в бизнес-процессах',
  logo: {
    image: require('@/assets/logo/LogoT1.svg'), // @/assets/logo/logo-white.svg для темной темы
    alt: 'T1 logo'
  },
//  pageBackgroundImage: require('@/assets/background/background.jpg'), // путь до кастомного фона
  aboutActivity: {
    name: 'Process Mining: неслабое звено. Устраняем уязвимые места в бизнес-процессах',
  description: [
    'Сегодня Process Mining — один из ключевых трендов в области бизнес-аналитики и управления процессами. Подход основан на сборе и анализе данных, накопленных в информационных системах и журналах событий. Process Mining выявляет уязвимые места, находит отклонения от регламентов, предлагает пути оптимизации и роботизации процессов. Подробнее о технологии и её возможностях расскажем на вебинаре.',
    '<b>Программа вебинара:</b>',
    '<ul> <li>Принцип работы и область применения Process Mining</li>  <li>Краткий обзор основных российских систем</li>  <li>«Быстрый старт»: как начать работать с технологией, что можно получить сразу на входе</li>  <li>Демонстрация и разбор восстановления процесса </li>',
    'Вебинар будет полезен владельцам процессов (финансовых, логистических, производственных, ИТ), аудиторам, сотрудникам, отвечающим за ЦТ и роботизацию. '
  ],
  date: '10 апреля',
  time: '11.00 – 12.30'
  },
  activities: [
    {
      tabName: '15.06.3023', // название таба, при многозальном мероприятии
      items: [
        {
          hash: 'OKXVcwnx',
          id: 2266,
          hallName: 'Первый зал' // название зала
        }
      ]
    }
  ],
  player: {
    title: 'Трансляция' // заголовок блока "Плеер"
  },
  schedule: {
    title: 'Программа' // заголовок блока "Расписание"
  },
  speakers: {
    //  Закомментируйте строку ниже если блок "Спикеры" не будет использоваться
    items: SpeakersConfiguration,
    title: 'Спикеры', // заголовок блока "Спикеры"
    shape: 'circle' // форма фотографий спикеров ('square' - квадрат, 'circle' - круг)
  },
  imageBlock: {
    title: 'Как пройти', // заголовок Блока с картинкой (оставить пустым (''), если не нужен)
    image: require('@/assets/image-block/Map.cad82bee.png'), // путь до изображения для блока с картинкой
    items: [
      'м. Красносельская/Бауманская, Спартаковский переулок 2с1, подъезд №7 (арт-пространство "Весна", 2 этаж).',
      '',
      '<a href="https://yandex.ru/maps/213/moscow/house/spartakovskiy_pereulok_2s1/Z04YcABiSkIOQFtvfXt2eXhrYw==/?ll=37.672379%2C55.778487&source=serp_navig&utm_source=share&z=16" target="_blank">Яндекс.Карты</a>'
    ]
  },
  info: {
    title: 'О нас', // заголовок Текстового блока (оставить пустым (''), если не нужен)
    items: [
      '<b>Т1 Интеграция</b> входит в <b>Холдинг Т1</b>, является одним из лидеров рынка системной интеграции в России, обладает большим набором компетенций, подтверждённых официальными статусами от ключевых мировых и отечественных производителей и разработчиков. Компания создана в 1992 году. Продуктовый портфель компании включает свыше 130 продуктов и услуг в области системной интеграции, промышленного инжиниринга, Big Data и машинного обучения, информационной безопасности, вычислительных комплексов, роботизации рутинных операций, процессной аналитики Process Mining, Интернета вещей, сетевых технологий и пр. Компанией реализовано более 2000 проектов в интересах заказчиков – государственных структур и крупнейших компаний ключевых отраслей экономики: операторов связи, финансовых организаций, промышленных, топливно-энергетических, транспортных и торговых предприятий.',
      '',
      'Центр компетенций систем управления ИТ и мониторинга обеспечивает полный цикл работ по внедрению систем мониторинга, ITSM/ESM, Process Mining <a href="https://t1.ru/competencies/item/upravlenie-sistem-uit-i-monitoringa/" target="_blank">Подробнее</a>',
      '<p><hr / color="#00AAE6"></br>',
      'В наших аккаунтах: новости, кейсы, тренды и экспертная аналитика. </br></br> <a href="https://habr.com/ru/companies/T1Holding/articles/"><img style="margin-right:50px" src="assets/image-block/habr.png" </a><a href="https://t.me/T1Holding"><img style="margin-right:50px" " src="assets/image-block/tg.png"</a>',
      'Подписывайтесь!'
    ]
  },
  partners: {
    //  Закомментируйте строку ниже если блок "Партнеры" не будет использоваться
    items: PartnersConfiguration,
    title: 'Партнеры' // заголовок блока "Партнёры"
  },
  footer: {
    copyright: '© Холдинг Т1,'
    // phone: '+7 926 260 53 22'
  }
}
